export default {
  allCalls: "Tutte",
  Unknown: "Sconosciuto",
  Multiple: "Multipli"
};

// @key: @#@"allCalls"@#@ @source: @#@"All calls"@#@
// @key: @#@"Unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"Multiple"@#@ @source: @#@"Multiple"@#@
